<template>
  <div class="order-refund">
    <!--标题-->
    <div class="breadcrumb">申请订单返款</div>
    <div class="rg-cn">
      <div class="dialog-content">
        <el-form ref="form" label-width="120px" :model="refundInfo" :rules="rules">
          <el-form-item label="平台号" prop="storeCode">
            <!-- <el-input v-model="refundInfo.storeCode"></el-input> -->
            <!-- <el-select clearable v-model="refundInfo.storeCode" :filter-method="filterMethod" filterable placeholder="请输入平台号">
              <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.code"></el-option>
            </el-select>
            <el-button v-if="!refundId" @click="verifyStore" round style="margin-left:10px;">验证平台</el-button> -->
            <div><span>{{ refundInfo.storeCode }}</span></div>
            <!-- <div><span style="color: red">{{ '平台名称：' + $route.query.storeName }}</span></div> -->
          </el-form-item>
          <el-form-item label="平台名称" prop="storeName">
            <div><span>{{ refundInfo.storeName }}</span></div>
          </el-form-item>
          <el-form-item label="实付总价：">
            <span>{{ priceReal }}</span>
          </el-form-item>
          <el-form-item label="订单返款金额" prop="totalPrice">
            <el-input v-model="refundInfo.totalPrice" type="number"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="refundInfo.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <order-item-component ref="orderItemRef" :orderNo="orderNo"></order-item-component>
    <div class="remaining-sum">
      <el-button type="primary" v-if="$hasPermission('oms:admin:orderRefund:apply') && !refundId" @click="deduction" round>申请返款 </el-button>
      <el-button type="primary" v-if="$hasPermission('oms:admin:orderRefund:audit') && refundId && refundInfo.auditStatus === 'APPLY'" @click="auditRefund('AUDITED')" round>审核通过 </el-button>
      <el-button v-if="$hasPermission('oms:admin:orderRefund:audit') && refundId && refundInfo.auditStatus === 'APPLY'" @click="auditRefund('REJECTED')" round> 审核拒绝 </el-button>
    </div>
  </div>
</template>
 <script>
import { auditRefund, getOrderRefund, refundAmount } from '@/api/refund'
import { storeQueryByStoreCode, storeQueryListByCode } from '@/api/crm'
import OrderItemComponent from '../../../components/OrderItem/index.vue'
export default {
  name: 'rebate',
  components: { OrderItemComponent },
  data () {
    return {
      orderNo: this.$route.query.orderNo,
      refundId: this.$route.query.refundId,
      priceReal: this.$route.query.priceReal,
      refundInfo: {
        totalPrice: '',
        remark: '',
        storeCode: this.$route.query.storeCode,
        storeName: this.$route.query.storeName
      },
      storeListByCode: [],
      rules: {
        storeCode: [
          { required: true, message: '请输入平台名称', trigger: 'change' }
        ],
        totalPrice: [
          { required: true, message: '请输入返现金额', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }

    }
  },
  watch: {
    'refundInfo.storeCode' () {
      this.refundInfo.storeName = ''
    }
  },
  created () {
    console.log('this.refundId ', this.refundId)
    this.refundId && this.getOrderRefund()
  },
  methods: {
    deduction () {
      console.log(this.refundInfo.storeName)
      // if (!this.refundInfo.storeName) {
      //   this.$message.error('请验证平台')
      //   return
      // }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        // 返款金额大于实付价格
        if (parseInt(this.refundInfo.totalPrice) > this.priceReal) {
          console.log('true', this.refundInfo.totalPrice, this.priceReal)
          this.$message.error('返款金额不能大于实付总价')
          return
        }
        refundAmount(this.orderNo, {
          refundType: 'REBATE',
          totalPrice: this.refundInfo.totalPrice,
          remark: this.refundInfo.remark,
          storeCode: this.refundInfo.storeCode
        }).then(res => {
          if (res.data.success === true) {
            this.$notify({
              title: '操作成功',
              message: '申请返现成功',
              type: 'success'
            })
            // this.getOrderRefund()
            this.$router.go(-1)
          }
        })
      })
    },
    getOrderRefund () {
      console.log(11111)
      getOrderRefund(this.refundId).then(res => {
        if (res.data.success) {
          this.refundInfo = res.data.data
          this.refundInfo.storeName = res.data.data.subOrders[0].order.storeCode
          this.refundInfo.storeCode = res.data.data.subOrders[0].order.storeName
          console.log('this.refundInfo', this.refundInfo)
        }
      })
    },
    auditRefund (auditStatus) {
      auditRefund({
        auditStatus: auditStatus,
        refundId: this.refundId
      }).then(res => {
        if (res.data.success) {
          this.$notify({
            title: '操作成功',
            message: auditStatus === 'REJECTED' ? '已拒绝' : '审核成功',
            type: 'success'
          })
          this.$router.go(-1)
          // this.getOrderRefund()
        }
      })
    },
    verifyStore () {
      storeQueryByStoreCode(this.refundInfo.storeCode).then(res => {
        if (res.data.success && res.data.data.exist) {
          this.refundInfo.storeName = res.data.data.name
          this.refundInfo.storeCode = res.data.data.code
        }
      })
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-content {
  padding: 20px;
}

.remaining-sum {
  display: flex;
  flex-flow: row-reverse;
  padding: 10px 30px;
}
</style>
